/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Refresh_Token_ReusedInputs */

const en_us2_auth_refresh_token_reused = /** @type {(inputs: Auth_Refresh_Token_ReusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session was ended for security reasons. Sign in again.`)
};

const pt_br2_auth_refresh_token_reused = /** @type {(inputs: Auth_Refresh_Token_ReusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua sessão foi encerrada por segurança. Entre novamente.`)
};

const es_419_auth_refresh_token_reused = /** @type {(inputs: Auth_Refresh_Token_ReusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu sesión se cerró por seguridad. Inicia sesión de nuevo.`)
};

const pt_pt2_auth_refresh_token_reused = /** @type {(inputs: Auth_Refresh_Token_ReusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua sessão foi terminada por segurança. Inicia sessão novamente.`)
};

const fr_fr2_auth_refresh_token_reused = /** @type {(inputs: Auth_Refresh_Token_ReusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta session a été fermée par sécurité. Reconnecte-toi.`)
};

const de_de2_auth_refresh_token_reused = /** @type {(inputs: Auth_Refresh_Token_ReusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Sitzung wurde aus Sicherheitsgründen beendet. Melde dich erneut an.`)
};

const it_it2_auth_refresh_token_reused = /** @type {(inputs: Auth_Refresh_Token_ReusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua sessione è stata chiusa per motivi di sicurezza. Accedi di nuovo.`)
};

/**
* | output |
* | --- |
* | "Your session was ended for security reasons. Sign in again." |
*
* @param {Auth_Refresh_Token_ReusedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_refresh_token_reused = /** @type {((inputs?: Auth_Refresh_Token_ReusedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Refresh_Token_ReusedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_refresh_token_reused(inputs)
	if (locale === "es-419") return es_419_auth_refresh_token_reused(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_refresh_token_reused(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_refresh_token_reused(inputs)
	if (locale === "de-DE") return de_de2_auth_refresh_token_reused(inputs)
	if (locale === "it-IT") return it_it2_auth_refresh_token_reused(inputs)
	return en_us2_auth_refresh_token_reused(inputs)
});
export { auth_refresh_token_reused as "auth.refresh_token_reused" }